class ResultMessagePopup extends HTMLElement {
    connectedCallback() {
        document.addEventListener('variant:added', (event) => {
            this.showMessage(event.detail.message, event.detail.status);
        });
    }

    showMessage(message, status) {
        // Apply the appropriate CSS variable based on the status
        const backgroundColor = status === 'success' ? 'var(--white)' : 'var(--white)';

        this.innerHTML = `
            <div class="result-message" style="background-color: ${backgroundColor};">
                ${message}
            </div>
        `;

        // Clear the message after 5 seconds
        setTimeout(() => {
            this.innerHTML = '';
        }, 5000);
    }
}

// Define the custom element
window.customElements.define("result-message-popup", ResultMessagePopup);
